import { render, staticRenderFns } from "./FormsAndPermissions.vue?vue&type=template&id=a34e68e6&scoped=true&"
import script from "./FormsAndPermissions.vue?vue&type=script&lang=js&"
export * from "./FormsAndPermissions.vue?vue&type=script&lang=js&"
import style0 from "./FormsAndPermissions.vue?vue&type=style&index=0&id=a34e68e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34e68e6",
  null
  
)

export default component.exports